<template>
  <div>
    <template v-if="hasCoworking">
      <preload-content :loading="loading" min-height="60vh">
        <template v-if="showCalendar">
          <white-bg style="margin-bottom: 20px">
            <button-component @click="showWorkplaces = !showWorkplaces">
              {{ showWorkplaces ? 'Скрыть схему рабочих мест' : 'Открыть схему рабочих мест' }}
            </button-component>
            <transition name="fade">
              <workplaces v-show="showWorkplaces"/>
            </transition>
          </white-bg>

          <CreationPopup
              ref="cpop"
              @create="$refs.cld.addEvent($event)"
              @save="editEvent" @opened="$refs.rpop.close()"
              :zone="zone"
          />
          <RequestPopup
              ref="rpop"
              @opened="$refs.cpop.close()"
              @mstart="$refs.cld.setStatus($event.id, 'working')"
              @pay="$refs.cld.setStatus($event.id, 'payed')"
              @mend="$refs.cld.setStatus($event.id, 'ended')"
              @mdnc="$refs.cld.setStatus($event.id, 'dnc')"
              @delete="$refs.delDiag.open($event)"
              @edit="$refs.cpop.open($event, true)"
          />
          <white-bg style="position: relative; overflow: hidden">
            <div class="mini-calendar" v-if="mobile">
              <mini-calendar
                  admin
                  white
                  hide-add
                  @addEvent="today()"
                  @input="goto($event.toDate())"
                  :value="getDate()"
              />
              <tabs :tabs="zones" @changeTab="changeTab" style="margin: 20px 25px;"/>
            </div>
            <div class="admin-calendar-header" v-if="!mobile">
              <div class="calendar-control">
                <div class="calendar-title">{{ api ? api.view.title : '' }}</div>
                <div>
                  <button class="control-btn" @click="prev()">&#x276E;</button>
                  <button class="today-btn" @click="today()">Сегодня</button>
                  <button class="control-btn" @click="next()">&#x276F;</button>
                </div>
              </div>
              <tabs :tabs="zones" @changeTab="changeTab"/>
            </div>
            <delete-dialog ref="delDiag" text="Вы действительно хотите удалить эту запись?" @confirm="confirmDelete"/>
            <AdministratorCalendarComponent
                @mobile="mobile = $event"
                ref="cld"
                @setApi="setApi"
                @select="$refs.cpop.open($event)"
                @eventClick="$refs.rpop.open($event)"
                :places="currentPlaces"
            />
            <div class="calendar-helper-section">
              <div class="mzm">
                Мастер забронировал место
              </div>
              <div class="mpr">
                Мастер приступил к работе
              </div>
              <div class="mzr">
                Мастер закончил работу
              </div>
              <div class="mnp">
                Мастер не пришел
              </div>
            </div>
          </white-bg>
        </template>
        <template v-if="!hasZones">
          <white-bg class="no-content">
            <h3>Список рабочих мест Вашего коворкинга пуст</h3>
          </white-bg>
        </template>
      </preload-content>
    </template>
    <template v-if="!hasCoworking">
      <white-bg class="no-content">
        <h3>Вы не являетесь владельцем коворкинга</h3>
      </white-bg>
    </template>
  </div>
</template>

<script>
import ButtonComponent from '@/components/ui/buttons/button-component'
import PreloadContent from '@/components/ui/preload-content';
import WhiteBg from '@/components/ui/white-bg';
import AdministratorCalendarComponent from './Calendar/AdministratorCalendarComponent'
import CreationPopup from './Calendar/CreationPopup';
import Tabs from '@/components/functional/Tabs'
import RequestPopup from './Calendar/RequestPopup'
import DeleteDialog from "./Calendar/deleteDialog";
import MiniCalendar from "@/pages/Cabinet/Master/CalendarApi/miniCalendar";
import Workplaces from "@/pages/Cabinet/Admin/Calendar/Workplaces";
import {mapGetters} from "vuex";


export default {
  name: 'AdministratorCalendar',
  components: {
    ButtonComponent,
    Workplaces,
    PreloadContent,
    MiniCalendar,
    DeleteDialog,
    RequestPopup,
    Tabs,
    WhiteBg,
    CreationPopup,
    AdministratorCalendarComponent
  },
  mounted() {
    if (!this.hasCoworking) return;
    this.loadZones().finally(() => {
      if (this.hasZones) this.$root.$on('setMainDate', (e) => this.goto(e));
    });
  },
  data: () => ({
    zones: null,
    api: null,
    activeTab: 1,
    mobile: false,
    showWorkplaces: false,
  }),
  computed: {
    ...mapGetters(['hasCoworking', 'getUser']),
    showCalendar() {
      return this.hasCoworking && this.hasZones;
    },
    hasZones() {
      return this.zones && this.zones.length;
    },
    zone() {
      return this.zones.find(t => t.isActive);
    },
    currentPlaces() {
      return this.zones.find(t => t.isActive).workplaces
    },
    loading() {
      return !this.zones;
    }
  },
  methods: {
    loadZones() {
      return this.$api.coworking.zone.list(this.getUser.coworking.id, {hasWorkplaces: true}).then(({data}) => {
        this.zones = data;
        if (this.hasZones) this.changeTab(0);
      });
    },
    setApi(e) {
      this.api = e;
      this.api.setOption('slotMinTime', this.getUser.coworking.start_at)
      this.api.setOption('slotMaxTime', this.getUser.coworking.end_at)
      this.$root.$emit('setSideDate', this.api.getDate())
    },
    prev() {
      this.api.prev();
      this.emitMini()
    },
    today() {
      this.api.today();
      this.emitMini()
    },
    next() {
      this.api.next();
      this.emitMini()
    },
    goto(date) {
      this.api.gotoDate(date)
    },
    getDate() {
      return this.api.getDate()
    },
    emitMini() {
      this.$root.$emit('setSideDate', this.api.getDate())
    },
    getTitle() {
      if (this.api != null) return this.api.view.title;
      else return ''
    },
    changeTab(idx) {
      this.zones = this.zones.map((tab, tabIdx) => {
        tab.isActive = idx === tabIdx
        return tab
      });
    },
    confirmDelete(id) {
      this.$api.admin.rent.destroy(id).then(() => {
        this.$toast.success('Удалено!');
        this.$eventHub.$emit('rent.changed');
        this.$refs.rpop.close()
      })
    },
    editEvent(e) {
      let event = this.api.getEventById(e.id)
      event.setProp('title', e.name)
      event.setStart(`${e.date}T${e.start}`)
      event.setEnd(`${e.edate}T${e.end}`)
    }
  },
  beforeDestroy() {
    this.$root.$off('setMainDate')
  }

}
</script>

<style scoped lang="scss">
.fade-enter-active {
  transition: opacity .5s;
}

.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.no-content {
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center
}

button {
  background-color: unset;
  border: unset;
}

.calendar-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mini-calendar {
  border-bottom: 1px solid #E5E5E5;
  margin: 0 -30px;
  padding: 0;

}

.calendar-title {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
}

.control-btn {
  color: #DBBFA7;
  margin-left: 19px;
  margin-right: 19px;
}

.today-btn {
  border: 1px solid #DBBFA7;
  border-radius: 5px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #DBBFA7;
  padding: 2px 15px;
}

.calendar-helper-section {
  display: flex;
  align-items: center;
  padding: 30px;
  padding-left: 0;
  margin-left: 90px;

  & div {
    position: relative;
    margin-right: 45px;

    &:after {
      content: '';
      width: 15px;
      height: 15px;
      position: absolute;
      top: 50%;
      margin-top: -8px;
      left: -25px;
      border-radius: 50%;
    }
  }

  .mzm:after {
    background-color: #E5E5E5;
    width: 13px;
    height: 13px;
    left: -27px;
    border: 2px solid #DBBFA7;
  }

  .mpr:after {
    background-color: #DBBFA7;
  }

  .mzr:after {
    width: 13px;
    height: 13px;
    left: -27px;
    border: 2px solid #DBBFA7;
  }

  .mnp:after {
    width: 13px;
    height: 13px;
    left: -27px;
    border: 2px solid #E5E5E5;
  }

}
</style>
